angular
  .module('fca-used')
  .directive('stopccp', StopCcpDirective);

/*
to inject log add $log as parameters StopCcpDirective()
StopCcpDirective.$inject = ['$log'];
 */

function StopCcpDirective() {
  return {
    scope: {},
    link: function (scope, element) {
      element.on('cut copy paste', function (event) {
        event.preventDefault();
      });
    }
  };
}
